import CryptoJS from 'crypto-js';

const isJsonString = (str: string) => {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
};

const isCanDecrypt = (bytes: any) => {
  try {
    JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  } catch (e) {
    return false;
  }
  return true;
};

export const getItem = (key: string) => {
  let item = localStorage.getItem(key);

  if (!item) {
    return null;
  }

  let isJson = isJsonString(item);
  if (!isJson) {
    return null;
  }

  let decryptedData = null;
  if (item.startsWith('"') && item.endsWith('"')) {
    let bytes = CryptoJS.AES.decrypt(JSON.parse(item), process.env.REACT_APP_API_SIGNATURE || '');

    let canDecrypt = isCanDecrypt(bytes);

    if (!canDecrypt) {
      decryptedData = null;
    } else {
      decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    }
  }

  return decryptedData;
};

export const setItem = (key: string, value: string | null) => {
  let ciphertext = CryptoJS.AES.encrypt(
    JSON.stringify(value),
    process.env.REACT_APP_API_SIGNATURE || ''
  ).toString();

  localStorage.setItem(key, JSON.stringify(ciphertext));
};

export const removeItem = (key: string) => {
  let item = JSON.parse(localStorage.getItem(key) ?? '');

  if (!item) {
    return undefined;
  }

  localStorage.removeItem(key);
};

export const clear = () => {
  let setting = localStorage.getItem('settingsState');
  localStorage.clear();
  localStorage.setItem('settingsState', setting ?? '');
};
